<template>
  <div>
    <p class="story-text-style">Your Choice has been made. You cannot travel around time</p>
    <section class="story-text-style story-button-container">
      <button class="story-btn-style" @click="navigateTo('/')">RESTART</button>
    </section>
  </div>
</template>

<script>
export default {
  name: "Story-Error",
  methods: {
    navigateTo(page) {
      this.$store.commit("resetUserData", true);
      this.$router.push(page);
    }
  }
};
</script>

<style></style>
